import { render, staticRenderFns } from "./returned-order-detail.vue?vue&type=template&id=afa26ece&"
import script from "./returned-order-detail.vue?vue&type=script&lang=js&"
export * from "./returned-order-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports